interface ToggleChipProps {
  label: string;
  active: boolean;
  onChange: (active: boolean) => void;
}

/**
 * A styled chip that toggles between active/inactive states.
 * Active: filled accent color. Inactive: muted outline.
 */
export function ToggleChip({ label, active, onChange }: ToggleChipProps) {
  return (
    <button
      class={`toggle-chip${active ? ' active' : ''}`}
      onClick={() => onChange(!active)}
      type="button"
    >
      {label}
    </button>
  );
}
